module.exports = __webpack_public_path__ + "static/l01-66d1e59f88f9afba96f30768db8c8473.png";